// extracted by mini-css-extract-plugin
module.exports =  {"item":"_02712f2b3b--item--VkFIZ","title":"_02712f2b3b--title--_mYos","finish-date":"_02712f2b3b--finish-date--koIS7"};